export default __webpack_public_path__ + "static/media/metamask-setup_image_6.38277fe2.jpg";